import { HigherApiClient } from 'src/api/client/ApiClient'
import { apiOps } from 'src/api/defs/apiOps'
import { OrderOffer } from 'src/api/defs/OrderOffer.type'
import { PlacedOrderInfo } from 'src/api/defs/PlacedOrderInfo.type'
import { OrderResult } from 'src/api/defs/OrderResult.type'
import { OrderSummary } from 'src/api/defs/OrderSummary.type'
import { OrderSummaryRequest } from 'src/api/defs/OrderSummaryRequest.type'
import { AutoregistrationPlacedOrderResponse } from 'src/api/defs/AutoregistrationPlacedOrderResponse.type'
import { AutoregistrationInvoicingDetails } from 'src/api/defs/AutoregistrationInvoicingDetails.type'
import { AutoregistrationInvoicingDetailErrors } from 'src/api/defs/AutoregistrationInvoicingDetailErrors.type'
import { PlaceOrderCmd } from '../../api/defs/PlaceOrderCmd.type'
import { trimStringsDeep } from 'src/utils/trimStringsDeep'

const ops = apiOps.Order
const PLACE_ORDER_TIMEOUT_MS = 30000

export class OrderApi {
    constructor(private api: HigherApiClient) {}

    offer = (boxId: number): Promise<OrderOffer> =>
        this.api.do(ops.offer, {
            pathParams: {
                boxId
            }
        })

    verifyAutoregistrationInvoicingDetail = (
        d: AutoregistrationInvoicingDetails
    ): Promise<AutoregistrationInvoicingDetailErrors> =>
        this.api.do(ops.verifyAutoregistrationInvoicingDetails, {
            data: trimStringsDeep(d)
        })

    orderWithLogin = (cmd: PlaceOrderCmd): Promise<PlacedOrderInfo> =>
        this.api.do(ops.placeWithLogin, {
            data: trimStringsDeep(cmd),
            timeout: PLACE_ORDER_TIMEOUT_MS
        })

    orderWithoutLogin = (
        cmd: PlaceOrderCmd
    ): Promise<AutoregistrationPlacedOrderResponse> =>
        this.api.do(ops.placeWithoutLogin, {
            data: trimStringsDeep(cmd),
            timeout: PLACE_ORDER_TIMEOUT_MS
        })

    summary = (cmd: OrderSummaryRequest): Promise<OrderSummary> =>
        this.api.do(ops.summary, {
            data: cmd
        })

    getByBoxName = (boxName: string): Promise<OrderOffer> =>
        this.api.do(ops.getByBoxName, {
            pathParams: {
                name: boxName
            }
        })

    status = (orderId: string): Promise<OrderResult> =>
        this.api.do(ops.status, {
            queryParams: {
                orderId
            }
        })
}
